import * as z from "zod";

export const completeHsaSessionInput = z.object({
  sessionToken: z.string().uuid(),
});

// `completedRedirectUrl` is null for STOREFRONT-initiated sessions — the
// PDP modal closes in place instead of redirecting.
export const completeHsaSessionOutput = z.object({
  completedRedirectUrl: z.string().url().nullable(),
});
